import React from 'react';
import './Picture.css';
import meW from '../../assets/imgs/meW.png';
import meB from '../../assets/imgs/meB.png';
import sleep from '../../utils/sleep';

export default class Content extends React.Component {
  constructor(props) {
    super(props);
    this.move = React.createRef();
  }

  handleChangePicForTouch = (event) => {
    let newLeft = 0;
    let isDown = true;
    const move = event.touches[0].target.closest(".move");
    const img = document.querySelector('.black');
      
    if(move != null) {
      const left = move.offsetLeft;
      let clientX = event.touches[0].clientX;

      move.ontouchmove = function(e) {
        if(!isDown) return;

        let _x = e.touches[0].clientX;
        newLeft = left + _x - clientX;

        if(newLeft > 0 && newLeft < 366) {
          move.style.left = newLeft+"px";
          img.style.width = newLeft + 2 +"px";
        }   
      }

      window.ontouchEnd = function() {
        isDown = false;
      }
    }
  }

  handleChangePicForMouse = (event) => {
    let newLeft = 0;
    let isDown = true;

    if(event.target.parentNode.className==="arrow"
      || event.target.className==="arrow" ) {
      const move = event.target.closest(".move");
      const img = document.querySelector('.black')
      const left = move.offsetLeft;
      let clientX = event.clientX;        

      window.onmousemove = function(e) {
        if(!isDown) return;

        let _x = e.clientX;
        newLeft = left + _x - clientX;

        if(newLeft > 0 && newLeft < 366) {
          move.style.left = newLeft+"px";
          img.style.width = newLeft + 2 +"px";
        }
      }

      window.onmouseup = function() {
        isDown = false;
      }
    }   
  }

  componentDidMount() {
    const { handleChangePicForMouse, handleChangePicForTouch } = this;

    sleep(4000)
    .then(() => {
      if(this.move.current !== null) {
        this.move.current.ontouchstart = (e) => handleChangePicForTouch(e);
        this.move.current.onmousedown = (e) => handleChangePicForMouse(e);  
      }
    })
  }

  render() {
    return ( 
      <div className="home-content-picture">
        <div className="img-container">
          <div className="white">
            <img src={meW} alt="selfie" />
          </div>

          <div className="black">
            <img src={meB} alt="selfie" />
          </div>

          <div className="move" ref={this.move}>
            <div className="arrow">
              <i className="fas fa-arrows-alt"></i>
            </div>
          </div>
        </div>
      </div>
    )
  }
}